module.exports = __webpack_public_path__ + "static/media/trophy.9f2d72ca.svg";